var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"detail-wrap"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.shopInfo.shop_content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }